import Select from "@insite/mobius/Select/Select";

export default Select;
export * from "./Select";
